<template>
  <div>
    <v-row>
      <v-spacer />
      <v-col>
        <auth-recaptcha
          @solved="captchaSolved"
          @expired="captchaExpired"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-spacer />
      <v-col class="text-right">
        <v-btn
          color="primary"
          :disabled="!canVerify"
          :loading="sending"
          @click="sendVerificationCode"
        >
          Send verification code
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { verifyPhoneNumberForResolver } from '@/utils/mfa'
import { AUTH_CAPTCHA_EXPIRED } from '@/utils/auth'
import AuthRecaptcha from '@/components/auth/AuthRecaptcha'

export default {
  name: 'VerifyMfaSendCode',
  components: {
    AuthRecaptcha
  },
  props: {
    resolver: { type: Object, required: true }
  },
  emits: ['codeSent', 'error'],
  data: function () {
    return {
      recaptchaVerifier: null,
      sending: false
    }
  },
  computed: {
    canVerify() {
      return this.recaptchaVerifier
    }
  },
  methods: {
    captchaSolved(recaptchaVerifier) {
      this.recaptchaVerifier = recaptchaVerifier
    },
    captchaExpired() {
      this.recaptchaVerifier = null
      const expiredError = new Error('ReCAPTCHA expired')
      expiredError.code = AUTH_CAPTCHA_EXPIRED
      this.$emit('error', expiredError)
    },
    async sendVerificationCode() {
      try {
        this.sending = true
        const verificationId = await verifyPhoneNumberForResolver({
          resolver: this.resolver,
          recaptchaVerifier: this.recaptchaVerifier
        })
        this.$emit('codeSent', verificationId)
      } catch (error) {
        this.$emit('error', error)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
